import { BasicUserResourceModel } from '@/modules/user/models/user-resource.model'
import { BankAccountType } from '@/modules/bank-account/models/bank-account-resource.model'
import {
  CampaignItemPaymentCollectionModelInAdmin,
  CampaignItemPaymentCollectionWithModel
} from '@/modules/campaign-item-payment/models/campaign-item-payment-collection.model'
import { Data } from '@/modules/shared/models/data'
import { MediaResourceModel } from '@/modules/media/models/media-resource.model'
import { BasicDepositBankAccountCollection } from '@/modules/deposit/models/deposit-collection.model'
import { BasicDepositBankAccountResourceModel } from '@/modules/deposit-bank-account/models/deposit-bank-account-resource.model'

export enum DepositPayableType {
  USER = 'User',
  MANUAL = 'Manual'
}

export enum DepositSettlementType {
  SHEBA = 'sheba',
  CARD = 'card',
  CHEQUE = 'cheque',
}

export enum DepositStatus {
  PENDING = 'pending',
  PAID = 'paid',
  CANCELLED = 'cancelled',
  FREEZE = 'freeze'
}

export interface BasicDepositResourceModel {
  account_owner_name: string | null
  amount: number
  author: BasicUserResourceModel
  id: number
  paid_at: string | null
  status: DepositStatus
}

export interface DepositResourceModel {
  account_owner_name: string | null
  amount: number
  author: BasicUserResourceModel
  id: number
  paid_at: string | null
  status: DepositStatus
  payable_type: DepositPayableType
  payable_id: number
  title: string
  tracking_number: string
  account_type: BankAccountType
  account_number: number
  card_number: number
  sheba: number
  created_at: string
  bank_account: BasicDepositBankAccountResourceModel
  reception: string
  reception_image: Array<File | MediaResourceModel>
  description: string
  telegram_activation: boolean
  campaign_item_payments: CampaignItemPaymentCollectionModelInAdmin
  national_id: number,
  registered_name: string,
  registered_number: number,
  economical_number: number,
  settlement_type: DepositSettlementType
  hidden: boolean,
}

export interface DepositResourceWithModel {
  payable_types: { [key in DepositPayableType]: string }
  statuses: { [key in DepositStatus]: string }
  account_types: { [key in BankAccountType]: string }
  deposit_bank_accounts: BasicDepositBankAccountCollection []
  campaign_item_payments_with: CampaignItemPaymentCollectionWithModel,
  settlement_types: { [key in DepositSettlementType]: string }
}

export type DepositResourceType = Data<DepositResourceModel> & DepositResourceWithModel
